module.exports = __webpack_public_path__ + "media/SuiteApp/assets/svg/img/common_signup-ad53b853f08cdb99101c9e334c4d7403.svg";